import { Navbar, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaHeart, FaRegHeart } from "react-icons/fa";

import { AiOutlineHome } from "react-icons/ai";
import { RiHistoryLine, RiCheckboxMultipleBlankLine } from "react-icons/ri";
import { IoFastFoodOutline, IoCartOutline } from "react-icons/io5";
import { MdLocalDining } from "react-icons/md";
import { GrCircleInformation } from "react-icons/gr";

const HeaderTop = function () {
  const { userInfo } = useSelector((state) => state.auth);
  const { orderId } = useParams();

  const navigate = useNavigate();

  const handleOrderHistoryClick = (e) => {
    e.preventDefault();
    if (userInfo?.token || userInfo?.visitorId) {
      navigate("/orderHistory");
    } else {
      navigate("/login", { state: { redirectTo: "/orderHistory" } });
    }
  };

  const handleTableOrderClick = (e) => {
    e.preventDefault();
    if (userInfo?.token) {
      navigate("/tableOrderDetails");
    } else {
      navigate("/login", { state: { redirectTo: "/tableOrderDetails" } });
    }
  };

  return (
    <header
      className="cyanThemeHeaderTop"
      style={{
        position: "sticky",
        height: "3rem",
        top: "0px",
        zIndex: 1,
        // margin: "0.03rem 0rem",
        // margin: "auto",
      }}
    >
      <Navbar
        style={{
          // height: "3rem",
          backgroundColor: "inherit",
          height: "inherit",
        }}
      >
        <Container
          style={{
            backgroundColor: "inherit",
          }}
        >
          <div
            style={{
              width: "80%",
              backgroundColor: "inherit",
              display: "flex",
              justifyContent: "space-evenly",
              zIndex: 1000,
              margin: "0.1rem",
              marginLeft: "0rem",
            }}
          >
            {orderId?.length !== 24 ? (
              <FaArrowLeft
                style={{
                  ...menuButtonStyle,
                  color: "grey",
                  fontSize: "1.8rem",
                  marginRight: "1rem",
                }}
                onClick={() => navigate(-1)}
              />
            ) : (
              <span style={{ marginLeft: "4rem" }}></span>
            )}
            <Link
              to={`/nearbyOutlets`}
              style={{ ...menuButtonStyle, textDecoration: "none" }}
            >
              <RiCheckboxMultipleBlankLine
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />
              outlets
            </Link>
            <Link
              to={`/${userInfo?.selectedOutletId?._id}`}
              style={{ ...menuButtonStyle, textDecoration: "none" }}
            >
              <AiOutlineHome
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />
              home
            </Link>
            <Link
              to={`/foodsList/${userInfo?.openedOutletGroup}`}
              style={{ ...menuButtonStyle, textDecoration: "none" }}
            >
              <IoFastFoodOutline
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />
              foods
            </Link>
            <Link
              style={{ ...menuButtonStyle, textDecoration: "none" }}
              onClick={handleOrderHistoryClick}
            >
              <RiHistoryLine
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />
              orders
            </Link>
            {userInfo?.token && (
              <Link
                to="/favourites"
                style={{ ...menuButtonStyle, textDecoration: "none" }}
              >
                <FaRegHeart style={{ width: "1.5rem", height: "1.5rem" }} />
                Favourites
              </Link>
            )}
            <Link
              to="/cartItems"
              style={{ ...menuButtonStyle, textDecoration: "none" }}
            >
              <IoCartOutline
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />

              {userInfo?.selectedItems &&
              Object.keys(userInfo?.selectedItems)?.length > 0 ? (
                <strong style={{ color: "orange" }}>
                  {Object.keys(userInfo?.selectedItems)?.length}
                </strong>
              ) : (
                <>cart</>
              )}
            </Link>

            {userInfo?.tableDetails?.floor && (
              <Link
                style={{ ...menuButtonStyle, textDecoration: "none" }}
                onClick={handleTableOrderClick}
              >
                <MdLocalDining
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    // marginBottom: "0.3rem",
                  }}
                />
                dining
              </Link>
            )}
            <Link
              to="/information"
              style={{
                ...menuButtonStyle,
                textDecoration: "none",
                marginLeft: "1rem",
              }}
            >
              <GrCircleInformation
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  // marginBottom: "0.3rem",
                }}
              />

              {userInfo?.selectedItems &&
              Object.keys(userInfo?.selectedItems)?.length > 0 ? (
                <strong style={{ color: "orange" }}>
                  {Object.keys(userInfo?.selectedItems)?.length}
                </strong>
              ) : (
                <>help</>
              )}
            </Link>
          </div>
        </Container>
      </Navbar>
    </header>
  );
};

const menuButtonStyle = {
  background: "none",
  border: "none",
  fontSize: "0.75rem",
  color: "white",
  cursor: "pointer",
  outline: "none",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  margin: "0.01rem 0rem",
};

export default HeaderTop;
